import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5811fb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"90%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "单据类型：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目名称：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "批次号：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "备案结果：", -1))
const _hoisted_13 = { class: "header_nr flexAlign" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "单据日期：", -1))
const _hoisted_15 = { class: "header_nr flexAlign" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "是否作废：", -1))
const _hoisted_17 = { class: "header_nr flexAlign" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "省：", -1))
const _hoisted_19 = { class: "header_nr flexAlign" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "市：", -1))
const _hoisted_21 = { class: "header_nr flexAlign" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "区：", -1))
const _hoisted_23 = { class: "header_nr flexAlign" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "小区：", -1))
const _hoisted_25 = { class: "header_nr flexAlign" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "幢：", -1))
const _hoisted_27 = { class: "header_nr flexAlign" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "门牌号：", -1))
const _hoisted_29 = { class: "header_nr flexAlign" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "工程地址：", -1))
const _hoisted_31 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"10px"}
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("新增报备")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("导出Excel模板")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_40 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_41 = { style: {"max-height":"calc(100vh - 220px)","overflow-y":"auto","padding-right":"6px"} }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "基本信息", -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title req-item" }, "渠道来源", -1))
const _hoisted_48 = { style: {"padding":"0 10px 10px"} }
const _hoisted_49 = { style: {"margin-top":"8px","display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#606266"} }, "其他渠道：", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "工程地址", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "报备附件（效果图、施工图）", -1))
const _hoisted_53 = { style: {"padding":"0 10px 10px"} }
const _hoisted_54 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_56 = { class: "paste_tip" }
const _hoisted_57 = ["href"]
const _hoisted_58 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "跟踪记录", -1))
const _hoisted_60 = { style: {"padding":"0 10px 10px"} }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("+ 添加跟踪记录")
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "备案结果与作废", -1))
const _hoisted_64 = {
  key: 0,
  style: {"color":"#e6a23c","font-size":"12px","margin":"0 0 6px 4px"}
}
const _hoisted_65 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("保 存")
const _hoisted_69 = { style: {"max-height":"calc(100vh - 220px)","overflow-y":"auto"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "基本信息", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "跟踪记录", -1))
const _hoisted_72 = {
  key: 1,
  style: {"color":"#909399"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "报备附件", -1))
const _hoisted_74 = { key: 2 }
const _hoisted_75 = ["href"]
const _hoisted_76 = {
  key: 3,
  style: {"color":"#909399"}
}
const _hoisted_77 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("确 定")

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { apiName } from '@/api/api';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Search, Plus } from '@element-plus/icons-vue';
import { reqProjectReportList, reqProjectReportDetails, reqProjectReportSave, reqProjectReportDelete, reqProjectReportAudit, reqProjectReportTemplateExport } from '@/api/projectReportApi';
import { reqWorkRecordsMyDept } from '@/api/api';
import { requestgetselfrole } from '@/api/api';
import areaData from '@/utils/areaData';

// ===== 经销商权限 =====
// 判定：角色为"经销商"，或所属部门名称包含"经销商"
// 限制：只能查看自己创建的报备；无审核权限；"备案结果与作废"下所有字段不可修改

export default /*#__PURE__*/_defineComponent({
  name: 'ProjectReport',
  setup(__props) {

const isDealer = ref<boolean>(false)
const loadDealerFlag = () => {
	requestgetselfrole({}).then((res: any) => {
		if (res.status === 1 && res.datalist === '经销商') {
			isDealer.value = true
			getList()
		}
	})
	// 按所属部门判定
	reqWorkRecordsMyDept({}).then((res: any) => {
		if (res.status === 1 && res.datalist && res.datalist.length) {
			const hit = res.datalist.some((d: any) => String(d.name || '').indexOf('经销商') >= 0)
			if (hit && !isDealer.value) {
				isDealer.value = true
				getList()
			}
		}
	})
}

const api = ref<string>(apiName)
const list = ref<any[]>([])
const loading = ref<boolean>(false)
const exporting = ref<boolean>(false)
const pageIndex = ref<number>(1)
const pageSize = ref<number>(10)
const pages = ref<any>({ totalCount: 0 })

const search = ref<any>({
	billtype: '',
	projectname: '',
	batchno: '',
	result: '',
	daterange: null as any,
	voidflag: '',
	province: '',
	city: '',
	district: '',
	community: '',
	building: '',
	houseno: '',
	address: ''
})

// 下拉选项
const billTypes = ['项目', '家具']
const styTypes = ['常规款式', '高定款式']
const natures = ['公寓', '平层', '联排', '别墅', '会所', '自建房', '其他']
const pstyles = ['法式','美式','老钱','新钱','轻奢','中式','新中式', '其他']
const channels = ['原业主', '原业主介绍', '设计师推荐', '装饰设计公司推荐', '品牌联盟推荐', '其他渠道']
const results = ['通过', '不通过', '提交待审核']
const ageGroups = ['35以下', '35-45', '45-55', '55以上']
const planLabels = ['现场对接测量时间', '初步方案完成时间', '预报价时间', '最终方案时间',
	'签最终合同下单时间', '放线和现场交接时间', '生成完成时间', '现场安装完成时间']

// ===== 省 / 市 / 区 级联 =====
const areaMap: any = areaData
const provinceList = computed(() => (areaMap.p || []).filter((v: string) => v && v !== '请选择'))
const cityList = computed(() => ((areaMap.c || {})[form.value.province] || []).filter((v: string) => v && v !== '请选择'))
const districtList = computed(() => ((areaMap.a || {})[`${form.value.province}-${form.value.city}`] || []))
const onProvinceChange = () => { form.value.city = ''; form.value.district = ''; buildAddress() }
const onCityChange = () => { form.value.district = ''; buildAddress() }
// 查询头的省/市/区级联（与表单内的级联相互独立）
const searchCityList = computed(() => ((areaMap.c || {})[search.value.province] || []).filter((v: string) => v && v !== '请选择'))
const searchDistrictList = computed(() => ((areaMap.a || {})[`${search.value.province}-${search.value.city}`] || []))
const onSearchProvinceChange = () => { search.value.city = ''; search.value.district = '' }
const onSearchCityChange = () => { search.value.district = '' }
// 手动改过地址后不再自动生成，避免覆盖人工修改
const addressEdited = ref<boolean>(false)
const buildAddress = () => {
	if (addressEdited.value) return
	const f = form.value
	f.address = `${f.province || ''}${f.city || ''}${f.district || ''}${f.community || ''}${f.building ? f.building + '幢' : ''}${f.houseno || ''}`
}

// ===== 表单 =====
const emptyForm = (): any => ({
	uuid: '',
	billtype: '项目',
	billdate: '',
	dealerno: '',
	batchno: '',
	contact: '', contacttel: '',
	ownername: '', ownertel: '',
	designer: '', designertel: '',
	manager: '', managertel: '',
	projectname: '', situation: '', competitor: '', newmaterial: '',
	stytype: '', nature: '', pstyle: '',
	province: '', city: '', district: '', community: '', building: '', houseno: '', address: '',
	areasize: '', houseuse: '', remark: '', customertype: '',
	woodtype: '', woodorderdate: '', crossregion: 0, invoice: 0,
	yydate1: '', yydate2: '', yydate3: '', yydate4: '', yydate5: '', deliverydate: '',
	channel: '', channelother: '',
	site1: '', site2: '', site3: '',
	plan1: '', plan2: '', plan3: '', plan4: '', plan5: '', plan6: '', plan7: '', plan8: '',
	filelist: '', result: '提交待审核', resultremark: '',
	voidflag: 0, voidreason: '', voiddate: '', agegroup: '',
	// report=项目信息报备；project=项目信息（挂在具体项目下，由项目管理页维护）
	infotype: 'report', projectuuid: '',
	// 报备有效期：新增时默认"当前时间+3个月"，不可修改（保存后以服务端写入为准）
	validdate: ''
})
// 默认报备有效期：当前时间 + 3 个月
const getDefaultValidDate = (): string => {
	const d = new Date()
	d.setMonth(d.getMonth() + 3)
	const p = (n: number) => String(n).padStart(2, '0')
	return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}
const form = ref<any>(emptyForm())
const channelList = ref<string[]>([])
const specials = ref<any[]>([])
const timeChanges = ref<any[]>([])
const tracks = ref<any[]>([])
const fileList = ref<any[]>([])
const editShow = ref<boolean>(false)
const saving = ref<boolean>(false)

// 模板中 ref 会自动解包，这里直接操作传入的数组本身
const addRow = (arr: any[], row: any) => { arr.push(row) }
const removeRow = (arr: any[], i: number) => { arr.splice(i, 1) }

// ===== 报备附件：Ctrl + V 粘贴上传 =====
const pasteUploading = ref<boolean>(false)
const uploadPasteFile = (file: File) => {
	pasteUploading.value = true
	const fd = new FormData()
	fd.append('file', file, file.name || ('paste_' + Date.now()))
	fetch(`${api.value}/frame/uploadfile1`, { method: 'POST', credentials: 'same-origin', body: fd })
		.then((r: any) => r.json())
		.then((res: any) => {
			if (res && res.errno === 0 && res.data && res.data[0]) {
				const rawName = res.data[0].name || ''
				const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
				fileList.value = fileList.value.concat([{ name, url: res.data[0].url, response: { data: [{ url: res.data[0].url, name: rawName }] } }])
				ElMessage.success('附件已上传')
			} else {
				ElMessage.error((res && res.msg) || '附件上传失败')
			}
		})
		.catch(() => ElMessage.error('附件上传失败'))
		.finally(() => { pasteUploading.value = false })
}
const onPaste = (e: ClipboardEvent) => {
	if (!editShow.value) return//仅新增/修改弹窗打开时生效
	const items = e.clipboardData && e.clipboardData.items
	if (!items) return
	const files: File[] = []
	for (let i = 0; i < items.length; i++) {
		const it: any = items[i]
		if (it && it.kind === 'file' && it.getAsFile) {
			const f = it.getAsFile()
			if (f) files.push(f)
		}
	}
	if (files.length === 0) return//纯文本粘贴不拦截
	e.preventDefault()
	files.forEach((f: File) => uploadPasteFile(f))
}
const removeFile = (i: number) => { fileList.value.splice(i, 1) }

// ===== 列表 =====
const getList = () => {
	loading.value = true
	const dr = search.value.daterange || []
	reqProjectReportList({
		pageIndex: pageIndex.value,
		pageSize: pageSize.value,
		billtype: search.value.billtype,
		projectname: search.value.projectname,
		batchno: search.value.batchno,
		result: search.value.result,
		startdate: dr.length === 2 ? dr[0] : '',
		enddate: dr.length === 2 ? dr[1] : '',
		voidflag: search.value.voidflag,
		province: search.value.province,
		city: search.value.city,
		district: search.value.district,
		community: search.value.community,
		building: search.value.building,
		houseno: search.value.houseno,
		address: search.value.address,
		// 仅显示"项目信息报备"，项目信息由项目管理页维护
		infotype: 'report',
		// 经销商只能查看自己创建的（后端也会强制过滤）
		onlymine: isDealer.value ? '1' : ''
	}).then((res: any) => {
		list.value = (res && res.data) || []
		pages.value.totalCount = (res && res.totalCount) || 0
		loading.value = false
	})
}
const searchList = () => { pageIndex.value = 1; getList() }
const handleSizeChange = () => { pageIndex.value = 1; getList() }
const handleCurrentChange = () => { getList() }
const resultTag = (r: string) => r === '通过' ? 'success' : (r === '不通过' ? 'danger' : 'warning')

// ===== 新增 / 修改 =====
const openAdd = () => {
	form.value = emptyForm()
	channelList.value = []
	specials.value = []
	timeChanges.value = []
	tracks.value = []
	fileList.value = []
	addressEdited.value = false
	// 新增时给出默认有效期预览（实际以服务端写入为准）
	form.value.validdate = getDefaultValidDate()
	editShow.value = true
}

// 导出"项目信息报备"Excel 模板（后端生成 .xlsx 并返回下载地址，与 datacollect/export 一致）
const exportTemplate = () => {
	exporting.value = true
	reqProjectReportTemplateExport({}).then((res: any) => {
		exporting.value = false
		if (res.status === 1 && res.datalist) {
			const path: string = String(res.datalist)
			const url = path.startsWith('http') ? path : `${window.location.origin}${path}`
			const ts = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-')
			const a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			a.download = `项目信息报备模板_${ts}.xlsx`
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			ElMessage({ message: '导出成功，已开始下载', type: 'success', duration: 1000 })
		} else {
			ElMessage({ message: res.msg || '导出失败', type: 'error', duration: 800 })
		}
	}).catch(() => {
		exporting.value = false
		ElMessage({ message: '导出失败', type: 'error', duration: 800 })
	})
}
const openEdit = (row: any) => {
	reqProjectReportDetails({ uuid: row.uuid }).then((res: any) => {
		if (res.status !== 1) { ElMessage.error(res.msg || '加载失败'); return }
		fillForm(res.datalist)
		editShow.value = true
	})
}
const fillForm = (d: any) => {
	form.value = Object.assign(emptyForm(), d.main || {})
	form.value.voidflag = Number(form.value.voidflag) || 0
	form.value.crossregion = Number(form.value.crossregion) || 0
	form.value.invoice = Number(form.value.invoice) || 0
	channelList.value = form.value.channel ? String(form.value.channel).split(',').filter((v: string) => v) : []
	specials.value = (d.specials || []).map((s: any) => ({ content: s.content || '' }))
	timeChanges.value = (d.timechanges || []).map((s: any) => ({
		changetype: s.changetype || '', oldtime: s.oldtime || '', newtime: s.newtime || '',
		modifyuser: s.modifyuser || '', modifytime: s.modifytime || '', reason: s.reason || ''
	}))
	tracks.value = (d.tracks || []).map((s: any) => ({
		tracktime: s.tracktime || '', trackuser: s.trackuser || '', trackway: s.trackway || '', conclusion: s.conclusion || ''
	}))
	fileList.value = form.value.filelist ? String(form.value.filelist).split(',').filter((v: string) => v)
		.map((u: string, i: number) => ({ name: '附件' + (i + 1), url: u })) : []
	addressEdited.value = true//编辑时保持原地址，不自动覆盖
}

const onVoidChange = (v: any) => {
	if (Number(v) === 1) {
		if (!form.value.voiddate) {
			const d = new Date()
			const m = String(d.getMonth() + 1).padStart(2, '0')
			const dd = String(d.getDate()).padStart(2, '0')
			form.value.voiddate = `${d.getFullYear()}-${m}-${dd}`
		}
	} else {
		form.value.voiddate = ''
		form.value.voidreason = ''
	}
}

// ===== 必填项校验 =====
// 必填字段（顺序即提示顺序）
const requiredFields: any[] = [
	{ prop: 'billtype', label: '单据类型' },
	{ prop: 'billdate', label: '单据日期' },
	{ prop: 'dealerno', label: '报备人编号' },
	{ prop: 'contact', label: '报备联系人' },
	{ prop: 'contacttel', label: '报备联系人电话' },
	{ prop: 'projectname', label: '项目名称' },
	{ prop: 'stytype', label: '款式' },
	{ prop: 'nature', label: '项目性质' },
	{ prop: 'pstyle', label: '项目风格' },
	{ prop: 'areasize', label: '预计平方数' },
	{ prop: 'channel', label: '渠道来源' },
	{ prop: 'address', label: '工程地址' }
]
// 返回第一个未填写的必填项名称；全部填写则返回空串
const checkRequired = (d: any, specialCount: number): string => {
	if (!d) return '数据'
	for (let i = 0; i < requiredFields.length; i++) {
		const f = requiredFields[i]
		const v = d[f.prop]
		if (v === undefined || v === null || String(v).trim() === '') return f.label
	}
	return ''
}

const save = () => {
	// 先把多选类的值写入 form，再做必填校验（否则渠道来源等会误判为空）
	form.value.channel = channelList.value.join(',')
	// 必填项校验
	const miss = checkRequired(form.value, specials.value.filter((s: any) => s.content).length)
	if (miss) { ElMessage.warning('请填写必填项：' + miss); return }
	// 附件（多个）以逗号分隔保存（渠道来源已在校验前赋值）
	form.value.filelist = fileList.value.map((f: any) =>
		(f.response && f.response.data && f.response.data[0]) ? f.response.data[0].url : (f.url || '')
	).filter((u: string) => u).join(',')
	const params: any = Object.assign({}, form.value)
	params.specials = JSON.stringify(specials.value.filter((s: any) => s.content))
	params.timechanges = JSON.stringify(timeChanges.value)
	params.tracks = JSON.stringify(tracks.value)
	saving.value = true
	reqProjectReportSave(params).then((res: any) => {
		saving.value = false
		if (res.status === 1) {
			ElMessage.success('保存成功')
			editShow.value = false
			getList()
		} else {
			ElMessage.error(res.msg || '保存失败')
		}
	}).catch(() => { saving.value = false })
}

// ===== 删除 =====
const del = (row: any) => {
	ElMessageBox.confirm('确定删除该报备吗？', '提示', { type: 'warning' }).then(() => {
		reqProjectReportDelete({ uuid: row.uuid }).then((res: any) => {
			if (res.status === 1) { ElMessage.success('删除成功'); getList() }
			else { ElMessage.error(res.msg || '删除失败') }
		})
	}).catch(() => {})
}

// ===== 明细 =====
const detailShow = ref<boolean>(false)
const detailLoading = ref<boolean>(false)
const detail = ref<any>({})
const detailFields = [
	{ label: '报备有效期', prop: 'validdate' },
	{ label: '单据类型', prop: 'billtype' },
	{ label: '单据日期', prop: 'billdate' },
	{ label: '报备人编号', prop: 'dealerno' },
	{ label: '联系人', prop: 'contact' },
	{ label: '联系人电话', prop: 'contacttel' },
	{ label: '项目名称', prop: 'projectname' },
	{ label: '款式', prop: 'stytype' },
	{ label: '项目性质', prop: 'nature' },
	{ label: '项目风格', prop: 'pstyle' },
	{ label: '预计平方数', prop: 'areasize' },
	{ label: '主要材质木种', prop: 'woodtype' },
	{ label: '预计木作下单时间', prop: 'woodorderdate' },
	{ label: '是否跨区域', prop: 'crossregion' },
	{ label: '是否开票', prop: 'invoice' },
	{ label: '渠道来源', prop: 'channel' },
	{ label: '其他渠道', prop: 'channelother' },
	{ label: '省', prop: 'province' },
	{ label: '市', prop: 'city' },
	{ label: '区', prop: 'district' },
	{ label: '小区', prop: 'community' },
	{ label: '幢', prop: 'building' },
	{ label: '门牌号', prop: 'houseno' },
	{ label: '工程地址', prop: 'address' },
	{ label: '备案结果', prop: 'result' },
	{ label: '备案结果备注', prop: 'resultremark' },
	{ label: '是否作废', prop: 'voidflag' },
	{ label: '作废原因', prop: 'voidreason' },
	{ label: '作废日期', prop: 'voiddate' },
	{ label: '备注', prop: 'remark' },
	{ label: '创建人', prop: 'createname' },
	{ label: '创建时间', prop: 'createtime' },
	{ label: '审核人', prop: 'auditname' },
	{ label: '审核时间', prop: 'audittime' }
]
const openDetail = (row: any) => {
	detailShow.value = true
	detailLoading.value = true
	detail.value = {}
	reqProjectReportDetails({ uuid: row.uuid }).then((res: any) => {
		detailLoading.value = false
		if (res.status === 1) {
			detail.value = res.datalist
			detail.value.main.voidflag = Number(detail.value.main.voidflag) === 1 ? '是' : '否'
			detail.value.main.crossregion = Number(detail.value.main.crossregion) === 1 ? '是' : '否'
			detail.value.main.invoice = Number(detail.value.main.invoice) === 1 ? '是' : '否'
		}
	})
}

// ===== 审核 =====
const auditShow = ref<boolean>(false)
const auditing = ref<boolean>(false)
const auditUuid = ref<string>('')
const auditForm = ref<any>({ result: '通过', resultremark: '' })
const openAudit = (row: any) => {
	if (isDealer.value) { ElMessage.warning('经销商无审核权限'); return }
	auditUuid.value = row.uuid
	auditForm.value = { result: '通过', resultremark: row.resultremark || '' }
	auditShow.value = true
}
// 审核通过前先校验必填项是否完整（不通过无需校验）
const submitAudit = () => {
	if (auditForm.value.result === '通过') {
		auditing.value = true
		reqProjectReportDetails({ uuid: auditUuid.value }).then((res: any) => {
			auditing.value = false
			if (res.status !== 1 || !res.datalist) {
				ElMessage.error('未获取到报备信息，无法审核')
				return
			}
			const d = res.datalist
			const miss = checkRequired(d.main, (d.specials || []).length)
			if (miss) {
				ElMessage.warning('必填项未填写完整（' + miss + '），不能审核通过')
				return
			}
			doAudit()
		}).catch(() => { auditing.value = false })
		return
	}
	doAudit()
}
const doAudit = () => {
	auditing.value = true
	reqProjectReportAudit({
		uuid: auditUuid.value,
		result: auditForm.value.result,
		resultremark: auditForm.value.resultremark
	}).then((res: any) => {
		auditing.value = false
		if (res.status === 1) { ElMessage.success('审核成功'); auditShow.value = false; getList() }
		else { ElMessage.error(res.msg || '审核失败') }
	}).catch(() => { auditing.value = false })
}

onMounted(() => {
	document.addEventListener('paste', onPaste)
	loadDealerFlag()
	getList()
})
onBeforeUnmount(() => {
	document.removeEventListener('paste', onPaste)
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              modelValue: search.value.billtype,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.billtype) = $event)),
              size: "small",
              placeholder: "全部",
              style: {"width":"100px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(billTypes, (t, i) => {
                  return _createVNode(_component_el_option, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.projectname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.projectname) = $event)),
              style: {"width":"140px"},
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.batchno,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.batchno) = $event)),
              style: {"width":"120px"},
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              modelValue: search.value.result,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search.value.result) = $event)),
              size: "small",
              placeholder: "全部",
              style: {"width":"120px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(results, (t, i) => {
                  return _createVNode(_component_el_option, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.daterange,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search.value.daterange) = $event)),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始",
              "end-placeholder": "结束",
              "value-format": "YYYY-MM-DD",
              size: "small",
              style: {"width":"240px"},
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              modelValue: search.value.voidflag,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((search.value.voidflag) = $event)),
              size: "small",
              placeholder: "全部",
              style: {"width":"90px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "否",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "是",
                  value: "1"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_select, {
              modelValue: search.value.province,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((search.value.province) = $event)),
              size: "small",
              filterable: "",
              placeholder: "全部",
              style: {"width":"110px"},
              clearable: "",
              onChange: onSearchProvinceChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(provinceList), (t, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_el_select, {
              modelValue: search.value.city,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((search.value.city) = $event)),
              size: "small",
              filterable: "",
              placeholder: "全部",
              style: {"width":"110px"},
              clearable: "",
              onChange: onSearchCityChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchCityList), (t, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_el_select, {
              modelValue: search.value.district,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((search.value.district) = $event)),
              size: "small",
              filterable: "",
              placeholder: "全部",
              style: {"width":"110px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchDistrictList), (t, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.community,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((search.value.community) = $event)),
              style: {"width":"110px"},
              onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.building,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((search.value.building) = $event)),
              style: {"width":"80px"},
              onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.houseno,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((search.value.houseno) = $event)),
              style: {"width":"80px"},
              onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.address,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((search.value.address) = $event)),
              style: {"width":"160px"},
              onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (searchList()), ["enter"])),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[19] || (_cache[19] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "success",
              size: "small",
              icon: _unref(Plus),
              onClick: _cache[20] || (_cache[20] = ($event: any) => (openAdd()))
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "warning",
              size: "small",
              loading: exporting.value,
              onClick: _cache[21] || (_cache[21] = ($event: any) => (exportTemplate()))
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ]),
    _hoisted_35,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
      border: "",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.billtype",
          label: "单据类型",
          width: "90",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.billdate",
          label: "单据日期",
          width: "110",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.projectname",
          label: "项目名称",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.address",
          label: "项目地址",
          "min-width": "180",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.areasize",
          label: "预计平方数",
          width: "110",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.validdate",
          label: "报备有效期",
          width: "140",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.contact",
          label: "联系人",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.ownername",
          label: "业主",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "备案结果",
          width: "110",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              size: "small",
              type: resultTag(scope.row.cell.result)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.cell.result || '-'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "是否作废",
          width: "90",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              size: "small",
              type: Number(scope.row.cell.voidflag)===1?'danger':'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(Number(scope.row.cell.voidflag)===1 ? '是' : '否'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.createname",
          label: "创建人",
          width: "90",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.createtime",
          label: "创建时间",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "是否提醒",
          width: "90",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              size: "small",
              type: Number(scope.row.cell.remindflag)===1?'success':'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(Number(scope.row.cell.remindflag)===1 ? '是' : '否'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.remindtime",
          label: "提醒时间",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "220",
          align: "center",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "primary",
              link: "",
              size: "small",
              onClick: ($event: any) => (openDetail(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "warning",
              link: "",
              size: "small",
              onClick: ($event: any) => (openEdit(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (!isDealer.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "success",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (openAudit(scope.row.cell))
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: ($event: any) => (del(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[23] || (_cache[23] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: editShow.value,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((editShow).value = $event)),
      title: form.value.uuid ? '修改项目信息报备' : '新增项目信息报备',
      width: "92%",
      top: "4vh",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[56] || (_cache[56] = ($event: any) => (editShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_67
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[57] || (_cache[57] = ($event: any) => (save())),
          loading: saving.value
        }, {
          default: _withCtx(() => [
            _hoisted_68
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode(_component_el_form, {
            "label-width": "110px",
            class: "two-col-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "报备有效期",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.validdate,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.value.validdate) = $event)),
                    disabled: "",
                    placeholder: "保存后自动生成（当前时间+3个月）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "单据类型",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.billtype,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((form.value.billtype) = $event)),
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(billTypes, (t, i) => {
                        return _createVNode(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "单据日期",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: form.value.billdate,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.billdate) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD",
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "报备人编号",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.dealerno,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((form.value.dealerno) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "报备联系人",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.contact,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((form.value.contact) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "报备人电话",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.contacttel,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.value.contacttel) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目名称",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.projectname,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form.value.projectname) = $event)),
                    placeholder: "请输入项目名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "款式",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.stytype,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((form.value.stytype) = $event)),
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(styTypes, (t, i) => {
                        return _createVNode(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目性质",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.nature,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((form.value.nature) = $event)),
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(natures, (t, i) => {
                        return _createVNode(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目风格",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.pstyle,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((form.value.pstyle) = $event)),
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pstyles, (t, i) => {
                        return _createVNode(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "预计木作下单平方数",
                class: "col-item req-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.areasize,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((form.value.areasize) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "主要材质木种",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.woodtype,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form.value.woodtype) = $event)),
                    placeholder: "如：橡木 / 胡桃木 / 樱桃木"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "预计木作下单时间",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: form.value.woodorderdate,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((form.value.woodorderdate) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD",
                    placeholder: "请选择",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "是否跨区域",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: form.value.crossregion,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((form.value.crossregion) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "是否开票",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: form.value.invoice,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((form.value.invoice) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_checkbox_group, {
              modelValue: channelList.value,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((channelList).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(channels, (t, i) => {
                  return _createVNode(_component_el_checkbox, {
                    label: t,
                    value: t,
                    key: i
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode(_component_el_input, {
                modelValue: form.value.channelother,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((form.value.channelother) = $event)),
                style: {"width":"300px"},
                placeholder: "选择“其他渠道”时填写"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_51,
          _createVNode(_component_el_form, {
            "label-width": "110px",
            class: "two-col-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "省",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.province,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((form.value.province) = $event)),
                    filterable: "",
                    placeholder: "请选择",
                    style: {"width":"100%"},
                    onChange: onProvinceChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(provinceList), (t, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "市",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.city,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((form.value.city) = $event)),
                    filterable: "",
                    placeholder: "请选择",
                    style: {"width":"100%"},
                    onChange: onCityChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (t, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "区",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.district,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((form.value.district) = $event)),
                    filterable: "",
                    placeholder: "请选择",
                    style: {"width":"100%"},
                    onChange: buildAddress
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(districtList), (t, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "小区",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.community,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((form.value.community) = $event)),
                    onChange: buildAddress
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "幢",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.building,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((form.value.building) = $event)),
                    onChange: buildAddress
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "门牌号",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.houseno,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((form.value.houseno) = $event)),
                    onChange: buildAddress
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "工程地址",
                class: "col-item req-item",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.address,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((form.value.address) = $event)),
                    placeholder: "根据省/市/区/小区/幢/门牌号自动生成，可修改",
                    onInput: _cache[48] || (_cache[48] = ($event: any) => (addressEdited.value = true))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_el_upload, {
                action: `${api.value}/frame/uploadfile1`,
                "file-list": fileList.value,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["action", "file-list"]),
              _createElementVNode("span", _hoisted_56, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传附件'), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                style: {"margin-top":"4px"}
              }, [
                _createElementVNode("a", {
                  href: `${api.value}${(f.response && f.response.data && f.response.data[0]) ? f.response.data[0].url : f.url}`,
                  target: "_blank",
                  style: {"color":"#409EFF","margin-right":"8px"}
                }, _toDisplayString(f.name || ('附件'+(i+1))), 9, _hoisted_57),
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (removeFile(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ]),
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tracks.value, (r, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "row_card"
              }, [
                _createVNode(_component_el_date_picker, {
                  modelValue: r.tracktime,
                  "onUpdate:modelValue": ($event: any) => ((r.tracktime) = $event),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "时间",
                  style: {"width":"160px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: r.trackuser,
                  "onUpdate:modelValue": ($event: any) => ((r.trackuser) = $event),
                  placeholder: "跟踪人员名称",
                  style: {"width":"150px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: r.trackway,
                  "onUpdate:modelValue": ($event: any) => ((r.trackway) = $event),
                  placeholder: "跟踪方式",
                  style: {"width":"150px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: r.conclusion,
                  "onUpdate:modelValue": ($event: any) => ((r.conclusion) = $event),
                  placeholder: "结论",
                  style: {"width":"260px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (removeRow(tracks.value,i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_61
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[49] || (_cache[49] = ($event: any) => (addRow(tracks.value,{tracktime:'',trackuser:'',trackway:'',conclusion:''})))
            }, {
              default: _withCtx(() => [
                _hoisted_62
              ]),
              _: 1
            })
          ]),
          _hoisted_63,
          (isDealer.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 经销商账号：备案结果与作废相关字段不可修改。 "))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form, {
            "label-width": "110px",
            class: "two-col-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "备案结果",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.result,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((form.value.result) = $event)),
                    placeholder: "请选择",
                    style: {"width":"100%"},
                    disabled: isDealer.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(results, (t, i) => {
                        return _createVNode(_component_el_option, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "是否作废",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: form.value.voidflag,
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((form.value.voidflag) = $event)),
                    onChange: onVoidChange,
                    disabled: isDealer.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_65
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_66
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "作废日期",
                class: "col-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.voiddate,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((form.value.voiddate) = $event)),
                    placeholder: "作废时自动生成",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "备案结果备注",
                class: "col-item",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.resultremark,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((form.value.resultremark) = $event)),
                    type: "textarea",
                    rows: 2,
                    disabled: isDealer.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "作废原因",
                class: "col-item",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.voidreason,
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((form.value.voidreason) = $event)),
                    type: "textarea",
                    rows: 2,
                    disabled: isDealer.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "备注",
                class: "col-item",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.remark,
                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((form.value.remark) = $event)),
                    type: "textarea",
                    rows: 2,
                    disabled: isDealer.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: detailShow.value,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((detailShow).value = $event)),
      title: "项目信息报备明细",
      width: "90%",
      top: "4vh"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[59] || (_cache[59] = ($event: any) => (detailShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_77
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_69, [
          _hoisted_70,
          _createVNode(_component_el_descriptions, {
            column: 2,
            border: "",
            size: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(detailFields, (f, i) => {
                return _createVNode(_component_el_descriptions_item, {
                  key: i,
                  label: f.label
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detail.value.main ? (detail.value.main[f.prop] || '-') : '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["label"])
              }), 64))
            ]),
            _: 1
          }),
          _hoisted_71,
          (detail.value.tracks && detail.value.tracks.length)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: detail.value.tracks,
                border: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "tracktime",
                    label: "时间",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "trackuser",
                    label: "跟踪人员",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "trackway",
                    label: "跟踪方式",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "conclusion",
                    label: "结论",
                    "min-width": "200"
                  })
                ]),
                _: 1
              }, 8, ["data"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, "无")),
          _hoisted_73,
          (detail.value.main && detail.value.main.filelist)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.main.filelist.split(','), (v, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: i,
                    href: `${api.value}${v}`,
                    target: "_blank",
                    style: {"color":"#409EFF","margin-right":"10px"}
                  }, "附件" + _toDisplayString(Number(i)+1), 9, _hoisted_75))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_76, "无"))
        ])), [
          [_directive_loading, detailLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: auditShow.value,
      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((auditShow).value = $event)),
      title: "备案审核",
      width: "500px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[63] || (_cache[63] = ($event: any) => (auditShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_78
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[64] || (_cache[64] = ($event: any) => (submitAudit())),
          loading: auditing.value
        }, {
          default: _withCtx(() => [
            _hoisted_79
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "备案结果" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: auditForm.value.result,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((auditForm.value.result) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "通过",
                      value: "通过"
                    }),
                    _createVNode(_component_el_option, {
                      label: "不通过",
                      value: "不通过"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: auditForm.value.resultremark,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((auditForm.value.resultremark) = $event)),
                  type: "textarea",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})